export default __webpack_public_path__ + "images/logo_delpfine.fb0ebb80.webp";